import React, { useState, useEffect } from 'react';
import { RiSearchLine, RiArrowLeftLine } from "react-icons/ri";
import { IoCloseOutline } from "react-icons/io5";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css'; // Import the default skeleton CSS
import axios from "axios";
import { mediaUrl, baseURL } from '../axiosInterceptor/axiosInterceptorC';

import CustomMultipleSelectDropdown from '../widgets/dropdown/CustomMultipleSelectDropdown';
import CustomSingleSelectDropdown from '../widgets/dropdown/CustomSingleSelectDropdown';

import homeBgVid1 from '../../assets/images/banner/bg1.mp4';
import homeBgVid1Webm from '../../assets/images/banner/bg1.webm';
import bannerPoster from '../../assets/images/banner/bannerPlaceholder.webp';
import { useNavigate } from 'react-router-dom';
import { useSearch } from "../searchContext/SearchContext"; // Import Context
import { useFilter } from "../filterContext/filterContext";

function HomeBanner() {
    const { saveFilterData } = useFilter();
    const [isLoading, setIsLoading] = useState(true);
    const [isSearchBoxVisible, setIsSearchBoxVisible] = useState(false);
    const [isMobileSearchPopupVisible, setIsMobileSearchPopupVisible] = useState(false);
    const [selectedDistrict, setSelectedDistrict] = useState(null);
    const [selectedTown, setSelectedTown] = useState(null);
    const [searchQuery, setSearchQuery] = useState("");
    const [townList, setTownList] = useState([]);
    const navigate = useNavigate();
    const [query, setQuery] = useState("");
    const { setSearchQueryNew } = useSearch();
    const [purpose, setPurpose] = useState([]);
    const [propertyType, setPropertyType] = useState([]);
    const [district, setDistrict] = useState([]);
    const [town, setTown] = useState([]);

    const handlePurposeChange = (e) => {
        setPurpose(e.target.value); // Update the state with the selected radio button value
        console.log("Updated Purpose:", e.target.value);
    };

    const categorizedOptions = [
        { category: 'All Residential', options: ['Residential Apartment', 'Residential Land', 'Residential House/Villa'] },
        { category: 'All Commercial', options: ['Commercial Shop', 'Commercial Office', 'Commercial Land', 'Commercial Building', 'Commercial Other'] },
        { category: 'All Industrial', options: ['Industrial Building', 'Industrial Land'] },
        { category: 'All Agricultural', options: ['Agricultural Land'] }
    ];

    const districtList = [
        {
            options: [
                'Trivandrum',
                'Kollam',
                'Alleppey',
                'Pathanamthitta',
                'Kottayam',
                'Idukki',
                'Ernakulam',
                'Thrissur',
                'Palakkad',
                'Malappuram',
                'Kozhikode',
                'Wayanad',
                'Kannur',
                'Kasargod'
            ]
        }
    ];

    const handleFilterSubmit = (e) => {
        e.preventDefault();
        //console.log("purpose :"+purpose)
        //console.log("propertyType :"+propertyType)
       // console.log("district :"+selectedDistrict)
       // console.log("town :"+selectedTown)
        // Save the filter data to context
        saveFilterData({ purpose, propertyType, selectedDistrict, selectedTown });

        // Optionally, trigger any API calls here to fetch filtered results
       navigate("/keralaplots/properties");
       document.body.style.overflow = 'inherit';
    };

    const handleSubmit = (e) => {
        e.preventDefault(); // Prevent page reload
    
        if (!query.trim()) return; // Prevent empty search
        //console.log("Search Query:", query);
        
        setSearchQueryNew(query); // Update the search query in context
        //localStorage.setItem("searchQuery", query); // Store in localStorage for persistence
    
        navigate("/keralaplots/properties"); // Redirect to property details page
        document.body.style.overflow = 'inherit';
    };

    


    

    const fetchTowns = async (district) => {
        if (!district) {
            //console.error("fetchTowns: District is undefined or null");
            return;
        }
        //console.log("Fetching towns for:", district);

        try {
            const response = await axios.get(`${baseURL}/get-towns/${district}`);
            //console.log("API Response:", response.data);

            if (response.data) {
                const formattedTownList = [{
                    options: response.data.map(town => town.area_name) // Adjust based on actual API response structure
                }];
                setTownList(formattedTownList);
                //setTownList([{ options: response.data.area_name }]);
               // console.log(townList)
            } else {
              //  console.log("hai")
                setTownList([{ options: [] }]);
            }
        } catch (error) {
           // console.error("Error fetching towns:", error);
        }
    };

    useEffect(() => {
        setIsLoading(false);
    }, []);

    const handleSearchBoxOpen = () => {
        setIsSearchBoxVisible(true);
        setIsMobileSearchPopupVisible(false);
        document.body.style.overflow = 'hidden'; // Prevent scrolling
    };

    const handleSearchBoxClose = () => {
        setIsSearchBoxVisible(false);
        document.body.style.overflow = 'inherit'; // Restore scrolling
    };

    const handleMobileSearchBoxOpen = () => {
        setIsMobileSearchPopupVisible(true);
        document.body.style.overflow = 'hidden'; // Prevent scrolling
    };

    const handleMobileSearchBoxClose = () => {
        setIsMobileSearchPopupVisible(false);
        document.body.style.overflow = 'inherit'; // Restore scrolling
    };

    // When district is selected, fetch towns for that district
    const handleDistrictChange = (selectedValue) => {
        const district = selectedValue?.name || selectedValue;
        //console.log("Changing district to:", district);
        //console.log("Resetting selected town...");
        setSelectedDistrict(district);
        setSelectedTown(null);
        fetchTowns(district);
    };

    const handlePropertyTypeChange = (selectedOptions) =>{
        setPropertyType(selectedOptions);  // Updates the state with the selected options
        console.log("Selected Property Types:", selectedOptions);
    }

    return (
        <>
            {isSearchBoxVisible && <div className="shimmer"></div>}

            {/* mobile search popup */}
            {isMobileSearchPopupVisible && (
            <div className="mobileSearchPopup">
                <div className="mobileSearchPopupHead">
                    <div className="closeMobileSearchPopup" onClick={handleMobileSearchBoxClose}>
                        <RiArrowLeftLine />
                    </div>
                </div>
                <div className="mobileSearchPopupBody">
                    <form onSubmit={handleFilterSubmit}>
                        <div className="bannerSearchBoxCol1">
                            {isLoading ? (
                                <div className='SkeletonLoader'>
                                    <Skeleton />
                                    <Skeleton />
                                    <Skeleton />
                                    <Skeleton />
                                </div>
                            ) : (
                                <>
                                    <div className="formGroup">
                                        <label htmlFor="">Purpose</label>
                                        <div className="radioBtn">
                                            <div className="radioBtnBox">
                                                <input type="radio" 
                                                id="sell" 
                                                name="purpose" 
                                                value="sell"
                                                checked={purpose === "sell"}
                                                onChange={handlePurposeChange}
                                                  />
                                                <label htmlFor="sell">Buy</label>
                                            </div>
                                            <div className="radioBtnBox">
                                                <input type="radio" 
                                                id="rent" 
                                                name="purpose" 
                                                value="Rent"
                                                checked={purpose === "Rent"}
                                                onChange={handlePurposeChange}
                                                />
                                                <label htmlFor="rent">Rent</label>
                                            </div>
                                            <div className="radioBtnBox">
                                                <input type="radio" 
                                                id="lease" 
                                                name="purpose" 
                                                value="Lease"
                                                checked={purpose === "Lease"}
                                                onChange={handlePurposeChange}
                                                />
                                                <label htmlFor="lease">Lease</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="formGroup">
                                        <CustomMultipleSelectDropdown options={categorizedOptions} label="Property Type" onChange={handlePropertyTypeChange} />
                                    </div>
                                    <div className="formGroup">
                                        <CustomSingleSelectDropdown
                                            options={districtList}
                                            label="District"
                                            onChange={handleDistrictChange}
                                        />
                                    </div>
                                    <div className="formGroup">
                                        <CustomSingleSelectDropdown 
                                            options={townList} 
                                            label="Town" 
                                            searchable={true} 
                                            value={selectedTown}
                                            onChange={setSelectedTown}
                                        />
                                    </div>
                                </>
                            )}
                        </div>

                        <div className="bannerSearchBoxCol2">
                            <div className="searchIdBtn" onClick={handleSearchBoxOpen}>Search By ID</div>
                            <div className="formBtnArea">
                                <button><RiSearchLine /> Search</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            )}

            {/* propertyIdSearchBox */}
            {isSearchBoxVisible && (
                <div className="propertyIdSearchBox">
                    <div className="closePropertyIdSearchBox" onClick={handleSearchBoxClose}>
                        <IoCloseOutline />
                    </div>
                    <h2>Search By ID</h2>
                    <form onSubmit={handleSubmit}>
                        <div className="formGroup">
                        <input 
                            type="text" 
                            placeholder="Search..." 
                            value={query}
                            onChange={(e) => setQuery(e.target.value)} 
                        />
                        </div>
                        <div className="formBtnArea">
                            <button>Search</button>
                        </div>
                    </form>
                </div>
            )}

            <section id="homeBanner">
                <div className="container">
                    <div className="homeBannerMain">
                        <div className="homeBannerThumbnail">
                            <video playsInline preload="auto" autoPlay muted loop poster={bannerPoster}>
                                <source src={homeBgVid1Webm} type="video/webm" />
                                <source src={homeBgVid1} type="video/mp4" />
                            </video>
                        </div>

                        <h1>Find The Most Residence For Your Needs</h1>
                        <p>Keralaplots.com is a new real estate platform that makes it easier to find your new property without paying any brokerage. Use our verified listing to ensure you find your dream property by contacting the owners directly.</p>

                        <div className="bannerSearchBox">
                            <form onSubmit={handleFilterSubmit}>
                                <div className="bannerSearchBoxCol1">
                                    {isLoading ? (
                                        <div className='SkeletonLoader'>
                                            <Skeleton />
                                            <Skeleton />
                                            <Skeleton />
                                            <Skeleton />
                                        </div>
                                    ) : (
                                        <>
                                            <div className="formGroup">
                                        <label htmlFor="">Purpose</label>
                                        <div className="radioBtn">
                                            <div className="radioBtnBox">
                                                <input type="radio" 
                                                id="sell" 
                                                name="purpose" 
                                                value="sell"
                                                checked={purpose === "sell"}
                                                onChange={handlePurposeChange}
                                                  />
                                                <label htmlFor="sell">Buy</label>
                                            </div>
                                            <div className="radioBtnBox">
                                                <input type="radio" 
                                                id="rent" 
                                                name="purpose" 
                                                value="Rent"
                                                checked={purpose === "Rent"}
                                                onChange={handlePurposeChange}
                                                />
                                                <label htmlFor="rent">Rent</label>
                                            </div>
                                            <div className="radioBtnBox">
                                                <input type="radio" 
                                                id="lease" 
                                                name="purpose" 
                                                value="Lease"
                                                checked={purpose === "Lease"}
                                                onChange={handlePurposeChange}
                                                />
                                                <label htmlFor="lease">Lease</label>
                                            </div>
                                        </div>
                                    </div>
                                            <div className="formGroup">
                                                <CustomMultipleSelectDropdown options={categorizedOptions} label="Property Type" onChange={handlePropertyTypeChange}  />
                                            </div>
                                            <div className="formGroup">
                                                <CustomSingleSelectDropdown
                                                    options={districtList}
                                                    label="District"
                                                    onChange={handleDistrictChange}
                                                />
                                            </div>
                                            <div className="formGroup">
                                                {isLoading ? (
                                                    <div className='SkeletonLoader'>
                                                        <Skeleton />
                                                        <Skeleton />
                                                        <Skeleton />
                                                    </div>
                                                ) : (
                                                    <CustomSingleSelectDropdown 
                                                        options={townList} 
                                                        label="Town" 
                                                        searchable={true} 
                                                        value={selectedTown}  // This must be updated
                                                        onChange={setSelectedTown}
                                                    />
                                                )}
                                            </div>
                                        </>
                                    )}
                                </div>

                                <div className="bannerSearchBoxCol2">
                                    <div className="searchIdBtn" onClick={handleSearchBoxOpen}>Search By ID</div>
                                    <div className="formBtnArea">
                                        <button><RiSearchLine /> Search</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="mobileSearchBox" onClick={handleMobileSearchBoxOpen}>
                            <RiSearchLine />
                            <span>Search...</span>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default HomeBanner;
